module.exports = __webpack_public_path__ + "sit/20260409173912/img/service.edbff227.png";